
import { mapState } from 'vuex'
import { TrackingHomeClick } from '@/reporter/track'
import { TRACK_ENTRY_MAP } from '@/utils/const/apply'
import allUrls from '@/utils/config'
import gjUtmConfig from '@/utils/gjUtm'

export default {
  name: 'Search',
  data() {
    return {
      gjUtmConfig,
      searchInput: '',
      site: this.$route.params.site,
      lang: this.$route.params.lang,
      trackMap: {
        waybill: TrackingHomeClick,
      },
      linkParams: { query: { scene: TRACK_ENTRY_MAP.homePage } },
      bgActive: '',
    }
  },
  computed: {
    ...mapState({
      resizeInfo: (state) => state.resizeInfo,
    }),
    isShowClearance() {
      const { site, lang } = this.$route.params
      return (
        site === 'cn' &&
        lang === 'sc' &&
        this.resizeInfo?.contentRect?.width >= 1200
      )
    },
    // PC 端 751~1200px 区间按视口宽度等比缩放，两侧各留 16px；其余区间不缩放
    pcScale() {
      const width = this.resizeInfo?.contentRect?.width
      if (!width || width >= 1200 || width <= 750) return 1
      return Math.floor(((width - 32) / 1200) * 1000) / 1000
    },
    // 缩放时内联占位高度（内联优先级高于后定义的 mixin，且 px 不经 px2rem 转换）
    pcWrapStyle() {
      const scale = this.pcScale
      const style = { '--pc-scale': scale }
      if (scale < 1) style.height = `${88 * scale}px`
      return style
    },
    getConsignLink() {
      if (this.site == 'jp') return allUrls.iuopGloballoginUrl
      return '/consign'
    },
  },
  methods: {
    // 处理点击查询跳转
    handleJumpTo() {
      this.$router.push({
        name: 'site-lang-support-querySupport-waybill',
        params: {
          site: this.$route.params.site,
          lang: this.$route.params.lang,
        },
        query: {
          No: this.searchInput,
        },
      })
    },

    track(type) {
      this.trackFn(type)
    },
    trackFn(name, properties) {
      this.trackMap[name](properties)
    },
    customsClearanceLink({ site, lang }) {
      return `/ocss-site/${site}/${lang}/support/customsClearance/home`
    },
    mouseenter() {
      this.bgActive = 'bg-active'
    },
    mouseleave() {
      this.bgActive = ''
    },
  },
}
